export const MUSIC_LIBRARY = [
  {
    id: "nirvana-smells-like-teen-spirit-audio",
    title: "Smells Like Teen Spirit",
    artist: "Nirvana",
    genre: "Rock",
    type: "audio",
    src: "/music-library/rock/Nirvana - Smells Like Teen Spirit (Official Music Video).mp3"
  },
  {
    id: "nirvana-smells-like-teen-spirit-video",
    title: "Smells Like Teen Spirit (Official Music Video)",
    artist: "Nirvana",
    genre: "Rock",
    type: "video",
    src: "/music-library/rock/Nirvana - Smells Like Teen Spirit (Official Music Video).mp4"
  },
  {
    id: "50-cent-many-men-audio",
    title: "Many Men (Wish Death)",
    artist: "50 Cent",
    genre: "Rap",
    type: "audio",
    src: "/music-library/rap/50 Cent - Many Men (Wish Death) (Dirty Version).mp3"
  },
  {
    id: "50-cent-many-men-video",
    title: "Many Men (Wish Death) (Dirty Version)",
    artist: "50 Cent",
    genre: "Rap",
    type: "video",
    src: "/music-library/rap/50 Cent - Many Men (Wish Death) (Dirty Version).mp4"
  }
];
